<template>
    <Dialog :visible="visible" :modal="true" :closable="false" :header="dialogTitle" @hide="$emit('close')">
        <div class="space-y-4">
            <p class="text-sm">{{ dialogMessage }}</p>
            <p class="font-medium">{{ formattedDate }}</p>
            
            <!-- Show reason if unblocking a day -->
            <div v-if="isUnblocking && blockedReason" class="bg-gray-100 p-3 rounded">
                <p class="text-xs text-gray-600">Motivo do bloqueio:</p>
                <p class="text-sm font-semibold">{{ blockedReason }}</p>
            </div>

            <!-- Show textarea only for blocking -->
            <Textarea 
                v-if="!isUnblocking"
                v-model="reason" 
                placeholder="Motivo do bloqueio" 
                class="w-full p-2 border rounded"
            ></Textarea>

            <p class="text-xs text-amber-600 font-semibold">{{ dialogSubtitle }}</p>
            
            <div class="flex justify-end gap-2 pt-4">
                <Button label="Cancelar" severity="secondary" @click="$emit('close')" />
                <Button 
                    :label="isUnblocking ? 'Desbloquear' : 'Confirmar bloqueio'" 
                    :icon="isUnblocking ? 'pi pi-lock-open' : 'pi pi-lock'" 
                    :severity="isUnblocking ? 'success' : 'danger'" 
                    @click="onConfirm($event)" 
                />
            </div>
        </div>
    </Dialog>
    <ConfirmPopup group="blockDay" />
</template>

<script>
import { ConfirmPopup, Dialog } from 'primevue';
import { Button } from 'primevue';
import { Textarea } from 'primevue';
import { parseISO, format } from 'date-fns';

export default {
    name: 'DialogBlockDay',
    components: { Dialog, Button, Textarea, ConfirmPopup },
    props: {
        visible: { type: Boolean, default: false },
        date: { type: String, default: null }, // expected 'YYYY-MM-DD'
        isBlocked: { type: Boolean, default: false }, // indicates if date is already blocked
        blockedReason: { type: String, default: null }, // reason why it's blocked
    },
    emits: ['confirm', 'close'],
    data() {
        return {
            reason: ''
        }
    },
    computed: {
        formattedDate() {
            if (!this.date) return '-';
            try {
                const d = parseISO(this.date);
                return format(d, 'dd/MM/yyyy');
            } catch (e) {
                return this.date;
            }
        },
        isUnblocking() {
            return this.isBlocked;
        },
        dialogTitle() {
            return this.isUnblocking ? 'Desbloquear dia' : 'Bloquear dia';
        },
        dialogMessage() {
            return this.isUnblocking ? 'Você está desbloqueando o dia:' : 'Você está bloqueando o dia:';
        },
        dialogSubtitle() {
            return this.isUnblocking ? 'Este dia voltará a estar disponível para reservas.' : 'Ninguém poderá criar reservas neste dia.';
        }
    },
    methods: {
        onConfirm(event) {
            if (!this.isUnblocking && (!this.reason || this.reason.trim() === '')) {
                this.sendToast('Erro', 'Por favor, insira um motivo para o bloqueio do dia.', 'error');
                return;
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: this.isUnblocking ? 'Tem certeza que deseja desbloquear este dia?' : 'Tem certeza que deseja bloquear este dia?',
                icon: this.isUnblocking ? 'pi pi-lock-open' : 'pi pi-lock',
                acceptLabel: this.isUnblocking ? 'Sim, desbloquear' : 'Sim, bloquear',
                rejectLabel: 'Cancelar',
                acceptClass: this.isUnblocking ? 'p-button-success' : 'p-button-danger',
                group: 'blockDay',
                accept: () => {
                    this.blockDay();
                }
            });
        },
        blockDay() {
            this.$emit('confirm', { 
                date: this.date, 
                reason: this.reason,
                isUnblocking: this.isUnblocking
            });
            // Reset reason for next time
            this.reason = '';
        },
    }
}
</script>

<style scoped></style>
